<script>
export default {
  name: 'VNodes',
  props: {
    vnodes: [Object, String],
  },
  setup(props) {
    return () => props.vnodes ?? '';
  },
};
</script>
